import { Component, Input } from '@angular/core';

@Component({
  selector: 'n-progress-bar',
  templateUrl: './n-progress-bar.component.html',
})
export class NProgressBarComponent {
  @Input() showValue = false;
  @Input() currentValue: number;
  @Input() maxValue: number;
  @Input() customLabel = '';
}
